'use strict';

/**
 * @fileoverview The ONE answer to "what kind of destination is this href?"
 * (LIFE-SHORTLISTED-001 P9.1, moved into the engine in P5.1).
 *
 * A block `url` field is validated against it when content is WRITTEN, and `<SmartLink>`
 * (`@puffin-core/marketing-shell`) renders by it — so "may this be stored" and "how is it rendered"
 * are one decision. Tenant-authored hrefs are untrusted: a protocol-relative `//host`,
 * `javascript:`, `data:`, a bare relative path or a non-string is INVALID — never a destination.
 *
 * @module @puffin-core/block-schema/hrefClassification
 */

/** The destination kinds. */
const HREF_KIND = Object.freeze({
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  MAILTO: 'mailto',
  TEL: 'tel',
  ANCHOR: 'anchor',
  INVALID: 'invalid',
});

/** The kinds that leave the site — an `outbound_clicked` event's subject. */
const OUTBOUND_KINDS = Object.freeze([HREF_KIND.EXTERNAL, HREF_KIND.MAILTO, HREF_KIND.TEL]);

/**
 * @param {*} href
 * @returns {string} one of `HREF_KIND`
 */
function classifyHref(href) {
  if (typeof href !== 'string') return HREF_KIND.INVALID;
  if (href.startsWith('#')) return HREF_KIND.ANCHOR;
  // Single-slash absolute only: `//host` is protocol-relative and must never become a route.
  if (href.startsWith('/')) return href.startsWith('//') ? HREF_KIND.INVALID : HREF_KIND.INTERNAL;
  if (/^https?:\/\//i.test(href)) return HREF_KIND.EXTERNAL;
  if (/^mailto:/i.test(href)) return HREF_KIND.MAILTO;
  if (/^tel:/i.test(href)) return HREF_KIND.TEL;
  return HREF_KIND.INVALID;
}

module.exports = { HREF_KIND, OUTBOUND_KINDS, classifyHref };
